import { render, staticRenderFns } from "./accessDetail.vue?vue&type=template&id=ca77b7a2"
import script from "./accessDetail.vue?vue&type=script&lang=js"
export * from "./accessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports